import actions from './actions';
import { RequestService as req } from "../../services/requestService";
import { Constants } from "../../config/constants";

const {
    fetchTeacherUnseenEmailsAction,
    fetchStudentUnseenEmailsAction,
    fetchClassTeacherZoomEmailsAction,
    fetchUnseenCommentsAction,
    fetchUnseenMessagesAction,
    fetchUnseenCVsAction,
    fetchUnseenOfficialEmailsAction,
    fetchUnseenPermissionUpdateAction,
    fetchUnseenTalentCVsAction
} = actions;


export const fetchTeacherUnseenEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}teacher-unseen-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchTeacherUnseenEmailsAction(cb)));
    };
};

export const fetchStudentUnseenEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}student-unseen-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchStudentUnseenEmailsAction(cb)));
    };
};

export const fetchClassTeacherZoomUnseenEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}class-teacher-zoom-unseen-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchClassTeacherZoomEmailsAction(cb)));
    };
};

export const fetchUnseenComments = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}get-unseen-comments`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUnseenCommentsAction(cb)));
    };
};

export const updateCommentSeenStatus = () => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.NOTIFICATIONS}update-seen-comments`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch(fetchUnseenComments());
            // await dispatch(fetchComment());
        });
    };
};

export const fetchUnseenMessages = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}get-unseen-messages`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUnseenMessagesAction(cb)));
    };
};

export const updateMessageSeenStatus = () => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.NOTIFICATIONS}update-seen-messages`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch(fetchUnseenMessages());
            // await dispatch(fetchComment());
        });
    };
};

export const fetchUnseenCVs = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}get-unseen-cv`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUnseenCVsAction(cb)));
    };
};

export const fetchUnseenTalentCVs = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}get-unseen-talent-cv`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUnseenTalentCVsAction(cb)));
    };
};

export const updateCVsSeenStatus = () => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.NOTIFICATIONS}update-seen-cv`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch(fetchUnseenCVs());
            // await dispatch(fetchComment());
        });
    };
};

export const updateTalentCVsSeenStatus = () => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.NOTIFICATIONS}update-talent-seen-cv`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch(fetchUnseenTalentCVs());
            // await dispatch(fetchComment());
        });
    };
};

export const fetchUnseenOfficialEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}get-unseen-official-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUnseenOfficialEmailsAction(cb)));
    };
};

export const fetchUnseenPermissionUpdate = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.NOTIFICATIONS}get-unseen-permission-update`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUnseenPermissionUpdateAction(cb)));
    };
};


export const updatePermissionUpdateSeenStatus = () => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.NOTIFICATIONS}update-seen-permission-update`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch(fetchUnseenPermissionUpdate());
            // await dispatch(fetchComment());
        });
    };
};